import { useEffect, useState } from 'react';

enum ViewportEnum {
  wideDesktop = 'wideDesktop',
  laptop = 'laptop',
  mobile = 'mobile',
}

export type Viewport = keyof typeof ViewportEnum;

export const getViewport = () => {
  const mediaQueryMobile = window.matchMedia(`(max-width: 720px)`);
  const mediaQueryLaptop = window.matchMedia(`(max-width: 1256px)`);

  if (mediaQueryMobile.matches) {
    return ViewportEnum.mobile;
  }

  if (mediaQueryLaptop.matches) {
    return ViewportEnum.laptop;
  }

  return ViewportEnum.wideDesktop;
};

export const useViewport = (initialState: Viewport | null | undefined = null) => {
  const [currentViewPort, setCurrentViewport] = useState<Viewport | null>(initialState);

  useEffect(() => {
    const resize = () => setCurrentViewport(getViewport());

    resize();

    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  return {
    viewport: currentViewPort,
    isMobile: currentViewPort === ViewportEnum.mobile,
    isLaptop: currentViewPort === ViewportEnum.laptop,
    isWideDesktop: currentViewPort === ViewportEnum.wideDesktop,
    isDefined: currentViewPort !== null,
  };
};
